(function (appSetup) {

	appSetup.apiFactory = function (app) {
		var api = {
			loading: {
				isLoading: false,
				callStack: [],
				init: function (callId, ignoreCallStack) {
					this.isLoading = true;

					app.components.getService("layout").loading.show();

					if (!ignoreCallStack && this.callStack.indexOf(callId) < 0) {
						this.callStack.push(callId);
					}
				},
				isThisCallRunning: function (callId) {
					var isRunning = false;
					if (this.callStack.indexOf(callId) > -1) {
						isRunning = true;
					}
					return isRunning;
				},
				onAjaxComplete: function (callId) {
					this.isLoading = false;

					app.components.getService("layout").loading.hide();

					var idx = this.callStack.indexOf(callId);
					if (idx > -1) {
						this.callStack.splice(idx, 1);
					}
				}
			},
			index: {
				sendRMContactFeedback: function (formData) {
					var url = app.constants.url.index.sendRMContactFeedback;
					var queryData = {
						firstName: formData.firstName,
						lastName: formData.lastName,
						comment: formData.comment,
						companyName: formData.companyName,
						emailId: formData.emailId,
						phoneNumber: formData.phoneNumber,
						countryCode: formData.countryCode
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				}
			},
			session: {
				timeOutHandle: null,
				checkSession: function (res, xhrStatus) {
					if (app.role.flags.isGuest) return;

					if (res.status == 600 || xhrStatus == 403) {
						var msg = res.message ? res.message : app.constants.messages.sessionTimeout;
						app.components.getService("modals").error.show(msg);

						setTimeout(function () {
							console.log("Session timeout");
							window.location.reload(true);
						}, 2500);

					} else {

						if (api.session.timeOutHandle) {
							window.clearTimeout(api.session.timeOutHandle);
						}

						api.session.timeOutHandle = setTimeout(function () {

							app.api.common.keepAlive().then(function (res) {
								if (res && res.status == 200) {

									return;

								} else {

									app.components.getService("modals").warning.show(app.constants.messages.sessionTimeout);

									setTimeout(function () {
										console.log("Session timeout");
										window.location.reload(true);
									}, 2500);

								}
							});
						}, app.config.timeToSessionRefresh);
					}
				}
			},
			call: function (url, data, type, traditional, ignoreCallStack) {

				if (!type) type = "GET";
				if (!traditional) traditional = false;
				if (!ignoreCallStack) ignoreCallStack = false;

				var callId = {
					url: url,
					data: data,
					type: type
				};

				callId = JSON.stringify(callId);

				if (this.loading.isThisCallRunning(callId)) {
					return $.Deferred().reject("Call is already running");
				}

				if (app.config.mocking) {
					var mock = mocks.callMock(url, data);
					if (mock) return mock;
				}

				this.loading.init(callId, ignoreCallStack);

				//rewrite to pass object as params
				var defAjax = $.ajax({
					url: url,
					data: data,
					cache: false,
					type: type,
					traditional: traditional,
					success: function (res, textStatus, xhr) {
						return api.session.checkSession(res, xhr.status);
					},
					error: function (e) {
						// error handler todo
						console.log(" IN ERROR FUNCTION - AJAX RESPONSE ================>> ",e);
						//app.components.getService("modals").warning.show(app.constants.messages.serverError);
						console.log(e);
					},
					complete: function (promise) {
						$.cookie("convertQuoteToOrder", undefined);
						api.loading.onAjaxComplete(callId);
					}
				});

				return defAjax;
			},
			callMultipart: function (url, data) {
				// used once for multipart form send at quotecheckout for custom user
				// move to call with params as object
				this.loading.init();
				console.log(data);
				return $.ajax({
					url: url,
					data: data,
					cache: false,
					contentType: false,
					processData: false,
					enctype: 'multipart/form-data',
					type: 'POST',
					success: function (response) {
						//alert(response);
					  },
					error: function (e) {
						// error handler
						// move to events
						app.components.getService("modals").warning.show(app.constants.messages.serverError);
						console.log(e);
					},
					complete: function () {
						api.loading.onAjaxComplete();
					}
				});

			},
			common: {
				shibbolethLogout: function () {
					var url = app.constants.url.common.shibbolethLogout;
					var queryData = {};
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				keepAlive: function () {
					var url = app.constants.url.common.keepAlive;
					var queryData = {};
					var type = "GET";
					var res = api.call(url, queryData, type);
					return res;
				},
				getCountries: function (mod) {
					var url = app.constants.url.common.getCountries;
					if (mod == "dropship") {
						url = app.constants.url.common.getCountriesForDropship;
					}
					var queryData = {};

					var cached = app.core.cache.getResponse(url, queryData);
					if (cached) {
						return cached;
					} else {

						queryData.CSRFToken = app.config.token;
						var type = "GET";
						var res = api.call(url, queryData, type);
						app.core.cache.saveResponse(url, queryData, res);
						return res;

					}
				},
				getStates: function (countryIso) {
					var url = app.constants.url.common.getStates;
					var queryData = {
						countryIso: countryIso
					};

					var cached = app.core.cache.getResponse(url, queryData);
					if (cached) {
						return cached;
					} else {
						queryData.CSRFToken = app.config.token;
						var type = "GET";
						var res = api.call(url, queryData, type);
						app.core.cache.saveResponse(url, queryData, res);

						return res;
					}
				}
			},
			customerRating: {
				saveOrderRating: function (data) {
					var url = app.constants.url.customerRating.saveOrderRating;
					var queryData = {
						rating: data.rating,
						ratingComment: data.ratingComment
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				}
			},
			emailNotification: {
				validateUnit: function (unitId) {
					var url = app.constants.url.emailNotification.validateUnit;
					var queryData = {
						b2bUnitId: unitId
					};
					queryData.CSRFToken = app.config.token;
					var type = "GET";
					var res = api.call(url, queryData, type);
					return res;
				},
				getPreferences: function (unitId) {
					var url = app.constants.url.emailNotification.getPreferences;
					var queryData = {
						b2bUnitId: unitId
					};
					queryData.CSRFToken = app.config.token;
					var type = "GET";
					var res = api.call(url, queryData, type);
					return res;
				},
				savePreferences: function (data) {
					var url = app.constants.url.emailNotification.savePreferences;
					var queryData = data;
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				}
			},
			registration: {
				getSalesManagers: function (formData) {
					var url = app.constants.url.registration.getSalesManagers;
					var queryData = formData;
					queryData.CSRFToken = app.config.token;
					var type = "GET";
					var res = api.call(url, queryData, type);
					return res;
				},
				getRoles: function () {
					var url = app.constants.url.registration.getRoles;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "GET";
					var res = api.call(url, queryData, type);
					return res;
				},
				getBuyerTypes: function () {
					var url = app.constants.url.registration.getBuyerTypes;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "GET";
					var res = api.call(url, queryData, type);
					return res;
				},
				registerCustomer: function (formData) {
					var url = app.constants.url.registration.registerCustomer;
					var queryData = formData;
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				}
			},
			supportLibrary: {
				getFirstCat: function () {
					var url = app.constants.url.supportLibrary.getFirstCat;
					var queryData = {};
					var cached = app.core.cache.getResponse(url, queryData);
					if (cached) {
						return cached;
					} else {

						queryData.CSRFToken = app.config.token;
						var type = "POST";
						var res = api.call(url, queryData, type);
						app.core.cache.saveResponse(url, queryData, res);
						return res;

					}
				},
				getSecondCat: function (firstCatCode) {
					var url = app.constants.url.supportLibrary.getSecondCat;
					var queryData = {
						categoryId: firstCatCode
					};

					var isSessionCache = true;
					var cached = app.core.cache.getResponse(url, queryData, isSessionCache);
					if (cached) {
						return cached;
					} else {

						queryData.CSRFToken = app.config.token;
						var type = "POST";
						var res = api.call(url, queryData, type);
						app.core.cache.saveResponse(url, queryData, res, isSessionCache);
						return res;

					}
					// queryData.CSRFToken = app.config.token;
					// var type = "POST";
					// var res = api.call(url, queryData, type);
					// return res;
				},
				getLiterature: function () {
					var url = app.constants.url.supportLibrary.getLiterature;
					var queryData = {};

					var isSessionCache = true;
					var cached = app.core.cache.getResponse(url, queryData, isSessionCache);
					if (cached) {
						return cached;
					} else {

						queryData.CSRFToken = app.config.token;
						var type = "POST";
						var res = api.call(url, queryData, type);
						app.core.cache.saveResponse(url, queryData, res, isSessionCache);
						return res;

					}
					// queryData.CSRFToken = app.config.token;
					// var type = "POST";
					// var res = api.call(url, queryData, type);
					// return res;
				},
				searchDocs: function (searchData) {
					var url = app.constants.url.supportLibrary.searchDocs;
					var queryData = searchData;

					var isSessionCache = true;
					var cached = app.core.cache.getResponse(url, queryData, isSessionCache);
					if (cached) {
						return cached;
					} else {

						queryData.CSRFToken = app.config.token;
						var type = "POST";
						var res = api.call(url, queryData, type);
						app.core.cache.saveResponse(url, queryData, res, isSessionCache);
						return res;

					}
					// queryData.CSRFToken = app.config.token;
					// var type = "POST";
					// var res = api.call(url, queryData, type);
					// return res;

				},
				searchFavourites: function () {
					var url = app.constants.url.supportLibrary.searchFavourites;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				addToFavourites: function (docCode) {
					var url = app.constants.url.supportLibrary.addToFavourites;
					var queryData = {
						contentCode: docCode
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				removeFromFavourites: function (pk) {
					var url = app.constants.url.supportLibrary.removeFromFavourites;
					var queryData = {
						entryPks: pk
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				uploadMotorDocs : function(formOriginData)
				{
					var url = app.constants.url.supportLibrary.uploadMotorDocs;
					var res = api.callMultipart(url, formOriginData).then(function (res) {
						console.log(res);
						return res;
					});
					return res;
				}
			},
			quoteCheckout: {
				checkoutQuote: function () {
					var url = app.constants.url.quoteCheckout.checkoutQuote;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					queryData.mandatoryFlag = context.mandatoryFlag;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				saveAndReviewQuote: function (formOriginData) {
					var url = app.constants.url.quoteCheckout.saveAndReviewQuote;
					var res = api.callMultipart(url, formOriginData).then(function (res) {
						return res;
					});
					return res;
				},
				reviewQuote: function () {
					var url = app.constants.url.quoteCheckout.reviewQuote;
					var queryData = {};
					var type = "GET";
					var res = api.call(url, queryData, type);
					return res;
				},
				confirmQuote: function () {
					var url = app.constants.url.quoteCheckout.confirmQuote;
					var queryData = {};
					var type = "GET";
					var res = api.call(url, queryData, type);
					return res;
				}
			},
			orderCheckout: {
				initCheckout: function () {
					var url = app.constants.url.orderCheckout.initCheckout;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					queryData.mandatoryFlag = ($.cookie("convertQuoteToOrder") ===null || $.cookie("convertQuoteToOrder") === undefined || $.cookie("convertQuoteToOrder") == '' ) ? context.mandatoryFlag : $.cookie("convertQuoteToOrder");
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				getShipmentTypes: function () {
					var url = app.constants.url.orderCheckout.getShipmentTypes;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var ignoreCallStack = true;
					var res = api.call(url, queryData, type, null, ignoreCallStack);
					return res;
				},
				getShipmentMethods: function (shipmentType) {
					var url = app.constants.url.orderCheckout.getShipmentMethods;
					var queryData = {
						shipPaymentMethod: shipmentType
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var ignoreCallStack = true;
					var res = api.call(url, queryData, type, null, ignoreCallStack);
					return res;
				},
				getShipmentCarriers: function (shipmentMethod) {
					var url = app.constants.url.orderCheckout.getShipmentCarriers;
					var queryData = {
						shipMethod: shipmentMethod
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var ignoreCallStack = true;
					var res = api.call(url, queryData, type, null, ignoreCallStack);
					return res;
				},
				getThirdPartyAddresses: function () {
					var url = app.constants.url.orderCheckout.getThirdPartyAddresses;
					//  huh?
					var queryData = {
						type: "header",
						entryNo: ""
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				saveThirdPartyAddress: function (addressData) {
					var url = app.constants.url.orderCheckout.createOrSetThirdPartyAddress;
					var queryData = {
						companyName: addressData.companyName,
						line1: addressData.line1,
						line2: "",
						townCity: addressData.townCity,
						stateRegion: addressData.stateRegion,
						postcode: addressData.postcode,
						countryIso: addressData.countryIso,
						addressType: "THIRDPARTY_ADDRESS",
						addressId: (addressData.id) ? addressData.id : "",
						code: "",
						saveInAddressBook: addressData.saveInAddressBook,
						selEntryNo: addressData.entryNo
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				deleteThirdPartyAddress: function (addressId) {
					var url = app.constants.url.orderCheckout.deleteThirdPartyAddress;
					var queryData = {
						addressId: addressId,
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				saveShippingAddress: function (addressData) {
					var url = app.constants.url.orderCheckout.createOrSetShippingAddress;
					var queryData = {
						companyName: addressData.companyName,
						line1: addressData.line1,
						line2: "",
						townCity: addressData.townCity,
						stateRegion: addressData.stateRegion,
						postcode: addressData.postcode,
						countryIso: addressData.countryIso,
						addressType: "DROPSHIP_ADDRESS",
						addressId: (addressData.id) ? addressData.id : "",
						code: "",
						saveInAddressBook: addressData.saveInAddressBook,
						entryNo: addressData.entryNo
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				saveShippingDetails: function (entriesData) {
					var url = app.constants.url.orderCheckout.saveShippingDetails;
					var queryData = {
						cartData: JSON.stringify(entriesData),
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				setBillingAddress: function (addressId) {
					var url = app.constants.url.orderCheckout.setBillingAddress;
					var queryData = {
						addressId: addressId,
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				confirmCheckout: function (entriesData) {
					var url = app.constants.url.orderCheckout.confirmCheckout;
					var queryData = {
						cartData: JSON.stringify(entriesData),
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				saveOrder: function () {
					var url = app.constants.url.orderCheckout.saveOrder;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				cancelOrder: function () {
					var url = app.constants.url.orderCheckout.cancelOrder;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
			},
			checkoutProfile: {
				getProfiles: function () {
					var url = app.constants.url.checkoutProfile.getProfiles;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				getProfile: function (code) {
					var url = app.constants.url.checkoutProfile.getProfile;
					var queryData = {
						profileId: code
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				applyProfile: function (code) {
					var url = app.constants.url.checkoutProfile.applyProfile;
					var queryData = {
						profileName: code
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				saveOrderAsProfile: function (data) {
					var url = app.constants.url.checkoutProfile.saveOrderAsProfile;
					var queryData = data;
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				deleteProfile: function (code) {
					var url = app.constants.url.checkoutProfile.deleteProfile;
					var queryData = {
						profileName: code
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				updateProfile: function (data) {
					var url = app.constants.url.checkoutProfile.updateProfile;
					var queryData = data;
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
			},
			b2bUnit: {
				search: function (formData) {
					var url = app.constants.url.b2bUnit.search;
					var queryData = {
						custIndexNo: "",
						custCity: formData.city,
						custName: formData.name,
						custState: formData.state,
						custCountry: formData.country,
						custZipcode: formData.zip,
						pageNumber: formData.pageNumber,
						resultsPerPage: formData.resultsPerPage
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				changeUnit: function (unit, setDefault) {
					if (!setDefault) setDefault = false;
					var url = app.constants.url.b2bUnit.changeUnit;
					var queryData = {
						customerIndex: unit.uid,
						chkDefaultUnit: setDefault
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				getAvailableUnits: function () {
					var url = app.constants.url.b2bUnit.getAvailableUnits;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				getBillingAddresses: function () {
					var url = app.constants.url.b2bUnit.getBillingAddresses;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				getShippingAddresses: function () {
					var url = app.constants.url.b2bUnit.getShippingAddresses;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				}
			},
			panda: {
				checkPriceAndAvailability: function (paData, isCartRequest) {
					var url = app.constants.url.panda.checkPriceAndAvailability;
					var queryData = {
						productCode: JSON.stringify(paData.products),
						b2bUnitId: paData.b2bUnitId,
					};

					if (isCartRequest) {
						queryData.cart = true;
					}

					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				sendFeedback: function (formData) {
					var url = app.constants.url.panda.sendFeedback;
					var queryData = {
						userId: app.config.user.id,
						userEmailId: app.config.user.email,
						nonStockCatalogCode: formData.product.stockId,
						nonStockPdtCode: formData.product.code,
						nonStockComments: formData.comment,
						nonStockQty: formData.qty,
						selectedIndex: formData.selectedIndex,
						unitNetPrice: formData.product.unitPrice,
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				}
			},
			cart: {
				update: function (itemData) {
					var url = app.constants.url.cart.update;
					var queryData = {
						products: JSON.stringify(itemData)
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				get: function () {
					var url = app.constants.url.cart.get;
					var queryData = {};
					// queryData.CSRFToken = app.config.token;
					var type = "GET";
					var res = api.call(url, queryData, type);
					return res;
				},
				remove: function (entriesToDelete) {
					// "entryNumbers:[0,2]
					// CSRFToken:271c61b1-dfba-4afc-827c-371e1e610e70"
					var url = app.constants.url.cart.remove;
					var queryData = {
						entryNumbers: JSON.stringify(entriesToDelete)
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				removeByPk: function (pks) {
					var url = app.constants.url.cart.removeByPk;
					var queryData = {
						pks: pks
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				addProducts: function (cartData) {
					var url = app.constants.url.cart.addProducts;
					var queryData = {
						products: JSON.stringify(cartData.products),
						b2bUnitId: cartData.b2bUnitId
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				addOrder: function (orderCode) {
					var url = app.constants.url.cart.addOrder;
					var queryData = {
						orderCode: orderCode,
						// b2bUnitId: cartData.b2bUnitId
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				convertQuote: function (quoteCode) {
					var url = app.constants.url.cart.convertQuote;
					var queryData = {
						quoteCode: quoteCode
						// b2bUnitId: cartData.b2bUnitId
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				detachOrderFromCart: function () {
					var url = app.constants.url.cart.detachOrderFromCart;
					var queryData = {};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				}
			},
			orders: {
				search: function (formData) {
					var url = app.constants.url.orders.search;
					var queryData = formData;
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var traditional = true;
					var res = api.call(url, queryData, type, traditional);
					return res;
				},
				getSavedOrders: function (formData) {
					var url = app.constants.url.orders.getSavedOrders;
					var queryData = formData;
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				editSavedOrder: function (code) {
					var url = app.constants.url.orders.editSavedOrder;
					var queryData = {
						savedOrderId: code
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				deleteSavedOrder: function (code) {
					var url = app.constants.url.orders.deleteSavedOrder;
					var queryData = {
						orderNumber: code
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				getOrder: function (query) {
					var url = app.constants.url.orders.getOrder;
					var queryData = {
						orderCode: query.code
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				getStatusFilters: function () {
					var url = app.constants.url.orders.getStatusFilters;
					var queryData = {};

					var cached = app.core.cache.getResponse(url, queryData);
					if (cached) {
						return cached;
					} else {
						queryData.CSRFToken = app.config.token;
						var type = "POST";
						var res = api.call(url, queryData, type);
						app.core.cache.saveResponse(url, queryData, res);
						return res;
					}
				}
			},
			quotes: {
				search: function (formData) {
					var url = app.constants.url.quotes.search;
					var queryData = formData;
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var traditional = true;
					var res = api.call(url, queryData, type, traditional);
					return res;
				},
				delete: function (orderCode) {
					var url = app.constants.url.quotes.delete;
					var queryData = {
						quoteCode: orderCode,
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				getQuote: function (query) {
					var url = app.constants.url.quotes.getQuote;
					var queryData = {
						quoteCode: query.code
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
				removeEntry: function (quoteCode, entryPk) {
					var url = app.constants.url.quotes.removeEntry;
					var queryData = {
						quoteCode: quoteCode,
						pk: entryPk
					};
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				}

			},
			whereToBuy: {
				getStoreLocations: function (formData) {
					var url = app.constants.url.whereToBuy.searchStores;

					var queryData = {
						radius: formData.radius,
						zipCode: formData.zipCode,
						countryCode: formData.countryCode,
						state:formData.state,
						city:formData.city,
						resultsPerPage: formData.resultsPerPage,
						pageNumber: formData.pageNumber,
						posLatitude: formData.posLatitude,
						posLongitude: formData.posLongitude
					};
					console.log("url wheretobuy========="+url);
					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				},
			},
			searchResults: {
				search: function (formData) {

					var url = app.constants.url.searchResults.search;
					var queryData = {};
					switch (formData.searchBy) {

						case "ac":
						case "dc":
						case "motors":
							queryData = {
								searchBy: formData.searchBy,
								hp: formData.hp,
								volts: formData.volts,
								categoryCode: formData.categoryCode, 
								orientation: formData.orientation,
								rpm: formData.rpm,
								enclosure: formData.enclosure,
								frameSize: formData.frameSize,
								goSymbolDesc: formData.goSymbolDesc,
								value: formData.search
							};
							break;
						case "parts":
							queryData = {
								searchBy: formData.searchBy,
								productFamily: formData.productFamily,
								categoryCode: formData.categoryCode,
								value: formData.search
							};
							break;
						case "partsplus":
							queryData = {
								searchBy: formData.searchBy,
								value: formData.search
							};
							break;
						case "compcatalog":
							queryData = {
								searchBy: "compcatalog",
								compCatalogNum: formData.search,
								value: formData.search
							};
							break;
						default:
							queryData = {
								value: formData.search,
								searchBy: "catalog"
							};
							break;
					}
					if(formData.sortBy != undefined && formData.sortBy != null)
					{
						queryData.sortBy = formData.sortBy;
					}
					queryData.pageNumber = formData.pageNumber;
					queryData.resultsPerPage = formData.resultsPerPage.toString();
					queryData.customerIndexType = formData.customerIndexType;
					var isSessionCache = true;
					var cached = app.core.cache.getResponse(url, queryData, isSessionCache);

					if (cached) {

						return cached;

					} else {
						var type = "POST";
						var traditional = true;
						queryData.CSRFToken = app.config.token;

						var res = api.call(url, queryData, type, traditional);

						app.core.cache.saveResponse(url, queryData, res, isSessionCache);
	
						return res;
					}


					// var type = "POST";
					// var traditional = true;
					// queryData.CSRFToken = app.config.token;

					// var res = api.call(url, queryData, type, traditional);

					// return res;
				},
				getLvMotorsFilterOptions: function (lvMotorType) {
					var url = app.constants.url.searchResults.getLvMotorsFilterOptions;

					var queryData = {
						searchBy: lvMotorType
					};

					var cached = app.core.cache.getResponse(url, queryData);

					if (cached) {

						return cached;

					} else {

						var res = api.call(url, queryData);

						app.core.cache.saveResponse(url, queryData, res);

						return res;
					}
				},
				getSubCategoriesForCode: function (categoryCode) {
					var url = app.constants.url.searchResults.getSubCategoriesForCode;

					var queryData = {
						categoryCode: categoryCode
					};

					var cached = app.core.cache.getResponse(url, queryData);

					if (cached) {

						return cached;

					} else {

						var res = api.call(url, queryData);

						app.core.cache.saveResponse(url, queryData, res);

						return res;
					}
				},
				getPcPartsFilterOptions: function () {
					var url = app.constants.url.searchResults.getPcPartsFilterOptions;

					var queryData = {};

					var cached = app.core.cache.getResponse(url, queryData);

					if (cached) {

						return cached;

					} else {

						var res = api.call(url, queryData);

						app.core.cache.saveResponse(url, queryData, res);

						return res;
					}
				},
			},
			mvMotorDetails: {
				requestQuote: function (code) {
					var url = app.constants.url.mvMotorDetails.requestQuote;

					var queryData = {
						productCode: code
					};

					queryData.CSRFToken = app.config.token;
					var type = "POST";
					var res = api.call(url, queryData, type);
					return res;
				}
			}
		};
		return api;
	};

	window.appSetup = appSetup;

})(window.appSetup || {});
